import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { auditor } from 'App';
import { IncompleteAuditsUI } from './IncompleteAudits.types';

export function useIncompleteAudits(page: number): UseQueryResult<IncompleteAuditsUI> {
  return useQuery(['incomplete audits', page], () => auditor.getIncompleteAudits(page), {
    select: ({ totalResults, compositeAudits }) => ({
      totalResults,
      compositeAudits: compositeAudits.map(
        ({ examSession, audit, anomalyCount, user, partner }) => ({
          auditStart: audit.startTime,
          auditor: `${user.firstName} ${user.lastName}`,
          partner: partner.name,
          examStartTime: examSession.startTime,
          examEndTime: examSession.endTime,
          auditUuid: audit.uuid,
          anomalyCount,
          uuid: examSession.uuid,
          specialPartner: partner.special,
        })
      ),
    }),
    staleTime: undefined,
  });
}
